<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'QR code Produk'"
          :fields="fields"
          :items="data"
          :editButton="voucherStatus === '3' ? true : false"
          :redirectDetail="false"
          :removeButton="voucherStatus === '3' ? true : false"
          :enableAddButton="voucherStatus === '3' ? true : false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
          @removeData="removeData"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol sm="6">
            <div class="form-group">
              <label for="voucher_seller">Pilih Seller</label>
              <model-select
                class="form-control"
                id="voucher_seller"
                :options="agentList"
                @input="callProduct"
                v-model="$v.voucherProductFormQr.agent_code.$model"
                :isError="$v.voucherProductFormQr.agent_code.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherProductFormQr.agent_code.$invalid"
                class="invalid-feedback-custom"
              >
                Agent should be filled.
              </div>
            </div>
          </CCol>

          <CCol sm="6">
            <div class="form-group">
              <label for="voucher_product"
                >Pilih produk yang ingin di berlakukan voucher</label
              >
              <model-select
                class="form-control"
                id="voucher_product"
                :options="productList"
                v-model="$v.voucherProductFormQr.product_code.$model"
                :isError="$v.voucherProductFormQr.product_code.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherProductFormQr.product_code.$invalid"
                class="invalid-feedback-custom"
              >
                Product should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
        <CRow>
          <CCol sm="3">
             <CInput
                    type="number"
                    label="Quantity"
                    min="0"
                    invalid-feedback="Quantity must be filled"
                    v-model="$v.voucherProductFormQr.qty.$model"
                    :is-valid="!$v.voucherProductFormQr.qty.$invalid"
                  />
            </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.voucherProductFormQr.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "VoucherProductQr",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Voucher Product",
      items: [],
      productList: [],
      addButton: false,
      isEdit: false,
      voucherProductFormQr: tableInterfaces.voucher_product_qr,
      isLoading: false,
      image: null,
      activeTab: 0,
      fields: [
        { key: "voucher_code", label: "Voucher Code", sorter: true },
        { key: "agent_code", label: "Agent Code", sorter: true },
        { key: "name", label: "Product Name", sorter: true },
        { key: "qty", label: "Quantity", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agentList: {
      type: [Array, Object],
      default: () => [],
    },
    voucher: {
      type: [Array, Object],
      default: () => [],
    },
    voucherProductQr: {
      type: [Array, Object],
      default: () => [],
    },
    voucherStatus: {
      type: String,
      default: null,
    },
  },
  validations: {
    voucherProductFormQr: {
      product_code: { required },
      agent_code: { required },
      qty: {  },
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.voucherProductQr;
    },
  },
  methods: {
    init: function () {
      this.$emit("update:");
    },

    // getProductList: function(){
    //     this.axios.get("/console/voucher/product-list").then((response) => {
    //     this.productList = response.data.data;
    //   });
    // },
    refreshVoucherProduct: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/voucher/voucher-product-qr/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // if (response.data.total_row.total_row == 2) {
            //   this.enableAddPrice = false;
            // }
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    callProduct: function () {
      this.Loading = true;
      this.voucherProductFormQr.product_code = null;
      this.axios
        .get(
          "/console/dropdown/product/by-agent/" +
            this.voucherProductFormQr.agent_code
        )
        .then((response) => {
          this.productList = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (item) {
      this.isEdit = true;
      this.voucherProductFormQr = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.voucher_product) {
        tableInterfaces.voucher_product[i] = null;
      }
      this.voucherProductFormQr = tableInterfaces.voucher_product;
    },
    removeData: function (item) {
      if (confirm("Do you want to remove this data ?")) {
        this.isLoading = false;
        this.axios
          .delete("console/voucher/remove-qr/" + item.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.refreshVoucherProduct(this.voucher.id);
          });
      }
      // bikin api untuk remove
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.voucherProductFormQr.voucher_code = this.voucher.voucher_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put(
              "console/voucher/voucher-product-qr/update",
              this.voucherProductFormQr
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherProduct(this.voucher.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post(
              "console/voucher/voucher-product-qr/add",
              this.voucherProductFormQr
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherProduct(this.voucher.id);
            });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
